export class ListQueryParams {
    q: string;
    loadFull : boolean = false;
    startPos : number = 0;
    maxResults : number = 10;
    courses : any;
    orderBy : string;
    attachToLMS : boolean = false;
    [key : string] : any;
}
